export default __webpack_public_path__ + "static/media/video.f8f586d8.mp4";